import { DefaultError, useQuery } from '@tanstack/react-query';
import { useTheme, useThemeActions } from 'hooks/useTheme';
import { THEME_TYPE } from 'store/theme';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import {
  IClientModuleConfiguration,
  IUserThemeSettingsResponse,
} from './types';

export const useGetClientConfiguration = (enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  const { setTheme, setThemeType } = useThemeActions();
  const { themeType } = useTheme();
  return useQuery<IUserThemeSettingsResponse, DefaultError>({
    queryKey: ['UserThemeSettings'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Configuration/GetClientConfiguration`,
      });

      const UserThemeSettings =
        await responseHandler<IUserThemeSettingsResponse>(response, {
          groupName: `useGetClientConfiguration`,
          onNotFound: () => {},
        });

      if (themeType === null || !UserThemeSettings.theme.canChangeThemeMode) {
        const mode =
          UserThemeSettings.theme.defaultThemeMode ?? THEME_TYPE.light;
        localStorage.setItem('theme-mode', `${mode}`);
        setThemeType(mode);
      }

      setTheme(UserThemeSettings.theme);

      return UserThemeSettings;
    },
    enabled,
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useGetClientModuleConfiguration = (enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IClientModuleConfiguration, DefaultError>({
    queryKey: ['client-module-configuration'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Configuration/GetClientModuleConfiguration`,
      });

      return await responseHandler<IClientModuleConfiguration>(response, {
        groupName: `useGetClientConfiguration`,
        onNotFound: () => {},
      });
    },
    enabled,
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
